<template>
    <div v-if="isVisible" class="loader-overlay">
        <div class="loader"></div>
        <span class="text" v-html="text"></span>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: {
            isVisible: {type: Boolean, required: true, default:true},
            text: {type: String, required: false, default: ""},
        },
}
</script>

<style lang="scss">
    .loader-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  cursor: pointer;
}

.loader-overlay span.text {
  display: inline-block;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
}

.loader-overlay .loader {
  content: "";
  height: 120px;
  width: 120px;
  margin: -15px auto auto -15px;
  position: absolute;
  top: calc(50% - 45px);
  left: calc(50% - 45px);
  border-width: 8px;
  border-style: solid;
  border-color: #fee600 #ccc #ccc;
  border-radius: 100%;
  animation: rotation .7s infinite linear;
}

.loader-overlay .loader:after {
  animation: loader-animate-after 1.5s ease-in-out infinite;
  clip: rect(0, 80px, 80px, 40px);
  content: '';
  border-radius: 50%;
  height: 80px;
  width: 80px;
  position: absolute;
}

@keyframes loader-animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(220deg);
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

@keyframes loader-animate-after {
  0% {
    transform: rotate(0deg);
    clip: rect(0, 80px, 80px, 40px);
  }
  25% {
    transform: rotate(90deg);
    clip: rect(0, 40px, 80px, 0);
  }
  50% {
    transform: rotate(180deg);
    clip: rect(0, 0, 80px, 40px);
  }
  75% {
    transform: rotate(270deg);
    clip: rect(0, 40px, 80px, 0);
  }
  100% {
    transform: rotate(360deg);
    clip: rect(0, 80px, 80px, 40px);
  }
}
</style>